var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1654482704923,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7071,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M702.72 960H316.544A182.272 182.272 0 0 1 134.4 777.92v-449.28A182.272 182.272 0 0 1 316.48 146.56h386.304a182.272 182.272 0 0 1 182.08 182.144v449.216A182.272 182.272 0 0 1 702.784 960zM316.544 236.096c-51.008 0-92.48 41.472-92.48 92.48v449.216c0 51.008 41.472 92.48 92.48 92.48h386.304c51.008 0 92.48-41.472 92.48-92.48V328.704c0-51.008-41.472-92.544-92.48-92.544H316.48V236.16z",
    "p-id": 7072
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M639.104 276.48H380.224a1.984 1.984 0 0 1-1.92-1.984V110.912c0-1.088 0.832-2.112 2.048-2.112h258.752c1.152 0 2.112 0.896 2.112 2.112v163.584a2.176 2.176 0 0 1-2.112 1.92z",
    "p-id": 7073
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M595.648 321.28H423.616a90.368 90.368 0 0 1-90.24-90.304V155.2C333.376 104.96 374.208 64 424.448 64h170.24c50.24 0 91.136 40.896 91.136 91.2V231.04a90.24 90.24 0 0 1-90.24 90.24zM424.576 153.6L423.04 230.976l172.608 0.64a0.64 0.64 0 0 0 0.64-0.64V155.2L424.64 153.6z m257.856 381.12h-345.6a44.8 44.8 0 1 1 0-89.6h345.664a44.8 44.8 0 1 1-0.064 89.6z m-154.88 204.288h-190.72a44.8 44.8 0 1 1 0-89.6h190.848a44.8 44.8 0 1 1-0.128 89.6z",
    "p-id": 7074
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.62ab135b.svg";
export { ForwardRef as ReactComponent };